module.exports = __webpack_public_path__ + "fa-regular-400.svg?20131f203cb63b55f0ec2d265e962697";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fortawesome/fontawesome-free-webfonts/webfonts/fa-regular-400.svg
// module id = 657
// module chunks = 3